<template>
    <Breadcrumbs main="Bonus Ui" title="Scrollable" />
    <div class="container-fluid">
        <div class="row">
            <customScrollbar />
            <smallScroll />
            <badgesScrollbar />
            <profileScrollable />
            <scrollableContent />
            <horizontalScrollbar />
            <bothSide />
        </div>
    </div>
</template>
<script lang="ts" setup>
import { ref, defineAsyncComponent } from 'vue'
const customScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/customScrollbar.vue"))
const smallScroll = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/smallScroll.vue"))
const badgesScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/badgesScrollbar.vue"))
const profileScrollable = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/profileScrollable.vue"))
const scrollableContent = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/scrollableContent.vue"))
const horizontalScrollbar = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/horizontalScrollbar.vue"))
const bothSide = defineAsyncComponent(() => import("@/components/theme/advance/scrollable/bothSide.vue"))
</script>